import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonitoreShopWindowComponent } from './monitore-shop-window.component';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { MatDividerModule } from '@angular/material/divider';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { ProductSelectorModule } from 'src/app/shared/components/product-selector/product-selector.module';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { ProductMonitoreModule } from 'src/app/shared/components/product-monitore/product-monitore.module';



@NgModule({
  declarations: [MonitoreShopWindowComponent],
  imports: [
    CommonModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    
    PaymentMethodsModule,
    MatDividerModule,
    ProductSelectorModule,
    CarouselSwiperModule,
    ProductMonitoreModule
  ],
  exports: [MonitoreShopWindowComponent]
})
export class MonitoreShopWindowModule { }
